import { initPanelSlider } from "./inc/panel-slider.js";
import { initHotspot } from "./inc/hotspot.js";
import { initFolderSlider } from "./inc/folder-slider.js";
import { initSectionCollapse } from "./inc/section-collapse.js";
import { initUltimateMembers } from "./inc/ultimate-members.js";
import { initKadenceFilterI18n } from "./inc/kadence-filter-i18n.js";
import { initCardSlider } from "./inc/card-slider.js";
import { initFocusScroll } from "./inc/focus-scroll.js";
import { initLinkLabels } from "./inc/link-labels.js";
import { initStructuralA11y } from "./inc/structural-a11y.js";
import { initHeaderReveal } from "./inc/header-reveal.js";

document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded');
    gsap_animation_section();
    initPanelSlider();
    initHotspot();
    initFolderSlider();
    initSectionCollapse();
    initUltimateMembers();
    initKadenceFilterI18n();
    initCardSlider();
    initFocusScroll();
    initLinkLabels();
    initStructuralA11y();
    initHeaderReveal();
});

//listen for resize
window.addEventListener('resize', () => {
    initPanelSlider();
});

const gsap_animation_section = () => {
    // console.log('gsap_animation_section');
    gsap.registerPlugin(ScrollTrigger);

        // Seleziona il path SVG
        const path = document.querySelector('.animated-path');
        if (!path) return;

        // Calcola la lunghezza totale del path
        const pathLength = path.getTotalLength();

        // Imposta i valori iniziali di stroke-dasharray e stroke-dashoffset
        path.style.strokeDasharray = pathLength;
        path.style.strokeDashoffset = -pathLength;

        // Crea l'animazione con ScrollTrigger (da destra verso sinistra)
        gsap.to(path, {
            strokeDashoffset: 0,
            ease: "none",
            scrollTrigger: {
                trigger: ".svg-section",
                start: "top right",
                end: "bottom left",
                scrub: 1.5,
                markers: true, // Imposta a true per vedere i marker di debug
                //onUpdate: (self) => console.log("progress:", self.progress)
            }
        });

        // Animazione di fade-in per il contenuto
        gsap.from(".content", {
            opacity: 0,
            y: 50,
            duration: .5,
            scrollTrigger: {
                trigger: ".content",
                start: "top 80%",
                end: "top 50%",
                scrub: 1
            }
        });

}
